import React, { memo, useEffect, useState } from 'react';
import { number, object, shape, string } from 'prop-types';

import { primary } from '@/colors/colorsV1';
import {
  styProgressBarOuter,
  styProgressBarInner,
  styLabelContainer,
} from './style';

const ProgressBar = (props) => {
  const { height, label, progress, color, ...rest } = props;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    let trimmedProgress = progress || 0;
    if (progress < 0) trimmedProgress = 0;
    if (progress > 100) trimmedProgress = 100;
    setWidth(trimmedProgress);
  }, [progress]);

  return (
    <div {...rest}>
      {/* TODO: consider to use html <progress />
        https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/progressbar_role#best_practices
      */}
      <div className={styProgressBarOuter({ height })} role="progressbar">
        <div className={styProgressBarInner({ height, width, color })} />
      </div>
      {label && (
        <div className={styLabelContainer}>
          {label.min && <span>{label.min}</span>}
          {label.max && <span>{label.max}</span>}
        </div>
      )}
    </div>
  );
};

ProgressBar.propTypes = {
  /**
   * Determine height of the progress bar
   */
  height: number,
  /**
   * Add label at the start and the end of the progress bar
   */
  label: shape({
    min: string,
    max: string,
  }),
  /**
   * current value of the progress bar
   */
  progress: number,
  /**
   * Props to pass a custom style
   */
  style: object,
  /**
   * Determine the color of the progress bar
   */
  color: string,
};

ProgressBar.defaultProps = {
  height: 8,
  label: null,
  progress: 0,
  style: {},
  color: primary
};

/**
 * Progress bar component,
 * Component for displays an indicator showing the completion progress of a task.
 * 
 * @example
 * const progress = 80
 * return (
 *   <ProgressBar progress={progress} color={Y500}/>
 * )
 */
const Memo = memo(ProgressBar);
export default Memo;
